
import { filterPerformanceDate } from './molecules/dashboard/filters/filter-performance-date';
import imeDashboardSetup from './molecules/dashboard/performance/performance-dashboard';

import './performance-dashboard.scss';

document.addEventListener('DOMContentLoaded', () => {
    imeDashboardSetup();
    filterPerformanceDate();
});



